module.exports = __webpack_public_path__ + "static/media/ContrastGoodOptimized.5e34021b.jp2";